import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button_Type_Classes } from "../button/button.component";

import Button from "../button/button.component";
import { PaymentFormContainer, FormContainer } from "./payment.form.style";


const PaymentForm=()=>{
    const stripe=useStripe();
    const elements=useElements()
    const paymentHandler =async(e)=>{
        e.preventDefault();

        if(!stripe || !elements){
            return;
        }

        const response= await fetch('/.netlify/functions/create-payment-intent', {
            method:'post',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ amount: 100})

        }).then(res=>res.json())
        
        const {paymentIntent:{client_secret}}= response



        

    }
    return ( 
        <PaymentFormContainer>
            <FormContainer onScroll={paymentHandler}>
            <CardElement />
            <h2> Credit Card Payment:  </h2>
            <Button buttonType={Button_Type_Classes.inverted}> Pay now </Button>
            </FormContainer>
        </PaymentFormContainer>
    )
}
export default PaymentForm;